import { estimatedColumnWidth } from "../helpers";
import { formatCurrency, formatDate } from "@/utils/helpers";

const textFormatter = (value) => String(value || "");
const amountFormatter = (value) => (value ? formatCurrency(String(value || "")) : "");
const dateFormatter = (value) => (value ? formatDate(new Date(value)) : "");

const column = (label, columnId, widthType, formatter = textFormatter) => ({
  label,
  value: true,
  columnId,
  width: estimatedColumnWidth(widthType),
  resizable: true,
  formatter,
});

// Same order and labels as the export (TenantOutstandingSheet), and only columns the report
// returns (TenantOutstandingReport.Columns). Keys are the API columns camelized by humps, so
// PDCNumber arrives as pDCNumber.
export default function getTenantOutstandingColumns() {
  return [
    column("Tenant Number", "tenantNumber", "number"),
    column("Tenant Name", "tenantName", "name"),
    column("Mobile", "tenantMobile", "phone"),
    column("Phone", "tenantPhone", "phone"),
    column("Contract Number", "contractNumber", "ContractNumber"),
    column("Component Number", "componentNumber", "ComponentNumber"),
    column("Component Name", "componentName", "Component"),
    column("Unit Number", "unitNumber", "UnitNumber"),
    column("Invoice Type", "invoiceType", "type"),
    column("Invoice Number", "invoiceNumber", "number"),
    column("Transaction Date", "transactionDate", "date", dateFormatter),
    column("Due Date", "dueDate", "date", dateFormatter),
    column("Invoice Amount", "totalOutstanding", "amount", amountFormatter),
    column("Collected", "totalCollected", "amount", amountFormatter),
    column("Balance", "grossBalance", "amount", amountFormatter),
    column("PDC Number", "pDCNumber", "PDCNumber"),
    column("PDC Amount", "pDCAppliedAmount", "amount", amountFormatter),
    column("Net Balance", "netBalance", "amount", amountFormatter),
    column("Remarks", "remarks", "comments"),
  ];
}
